import { useI18n } from 'vue-i18n';

export function useCustomT(language) {
  const { t } = useI18n();
  
  return (key, options) => {
    let currentLanguage = language;
    if (!currentLanguage) {
      currentLanguage = localStorage.getItem('selectedLocale');
    }

    if (currentLanguage) {
      return t(key, options, { locale: currentLanguage });
    }
    return t(key, options);
  };
}
